import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { SharedUser } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<SharedUser>>>;

const getSharedUsersOnGroup = (id: string): ReturnType => {
    return Request.get(`/groups/${id}/users`);
};

export default getSharedUsersOnGroup;
